import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CloturecaisseComponent } from './cloturecaisse.component';
import { PopupcloturecaisseComponent } from './popupcloturecaisse/popupcloturecaisse.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule, MatChipsModule } from '@angular/material';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { NgxPrintModule } from 'ngx-print';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { QuickInfoWidgetModule } from '../dashboard/widgets/quick-info-widget/quick-info-widget.module';
import { MatSelectSearchModule } from '../historiquecarte/mat-select-search/mat-select-search.module';

@NgModule({
  declarations: [CloturecaisseComponent, PopupcloturecaisseComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    BreadcrumbsModule,
    MatInputModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    FurySharedModule,
    MatSelectSearchModule,
    QuickInfoWidgetModule,
    NgxPrintModule
  ],
  entryComponents: [PopupcloturecaisseComponent]

})
export class CloturecaisseModule { }
